import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Layout from "../layout/index.vue";
import Home from "../views/Home.vue";
import Shop from "../views/Shop.vue";
import Terms from "../views/Terms.vue";
import Inquiry from "../views/Inquiry.vue";
import { MaskModule } from "@/store/index";
import ConfigModule from "@/store/modules/config";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/",
        name: "Home",
        component: Home
      },
      {
        path: "/page/shop/:gameId",
        name: "Shop",
        component: Shop
      },
      {
        path: "/page/terms-of-service",
        name: "TermsOfService",
        meta: { termTitleKey: "categoryForUserTermTitle", termContentKey: "categoryForUserTermContent" },
        component: Terms
      },
      {
        path: "/page/privacy-policy",
        name: "PrivacyPolicy",
        meta: { termTitleKey: "categoryForPrivacyTermTitle", termContentKey: "categoryForPrivacyTermContent" },
        component: Terms
      },
      {
        path: "/page/yo-topup",
        name: "YoTopup",
        meta: { termTitleKey: "categoryForAgreementTitle", termContentKey: "categoryForAgreementContent" },
        component: Terms
      },
      {
        path: "/page/inquiry",
        name: "Inquiry",
        component: Inquiry
      },
      {
        path: "*",
        redirect: "/"
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

let langInitialized = false;

router.beforeEach(async (to, from, next) => {
  MaskModule.closeMask(true);
  if (!langInitialized) {
    langInitialized = true;
    ConfigModule.setLangLoading(true);
    try {
      await ConfigModule.initLang();
    } finally {
      ConfigModule.setLangLoading(false);
    }
  }
  next();
});

export default router;
